import { Component } from '@angular/core';
import { AuthService } from '../../services/auth';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// import { MatCard, MatCardContent, MatCardFooter, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { getAuth, sendPasswordResetEmail } from '@angular/fire/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule,MatFormFieldModule,MatInputModule,MatButtonModule,FormsModule,
     FormsModule,
    MatIcon
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login {

  constructor(private authService: AuthService , private router: Router) {}

  email: string = '';
  password: string = '';
  error: string = '';
  resetEmail: string = ''; // Separate field for reset email
  resetSuccess: string = '';
  resetError: string = '';
  showReset: boolean = false; // Toggle for reset section
  passwordType = 'password';

  async onLogin() {
    try {
      await this.authService.login(this.email, this.password);
    } catch (error: any) {
      this.error = error.message || 'Login failed';
    }
  }

  async togglePassword(){
    if(this.passwordType==='password'){
      this.passwordType = 'text'
    } else {
      this.passwordType = 'password'
    }
  }

  // onResetPassword(event: Event) {
  //   event.preventDefault(); // Prevent default link behavior
  //   if (!this.resetEmail) {
  //     this.resetEmail = this.email; // Use login email as default
  //   }
  //   const auth = getAuth();
  //   sendPasswordResetEmail(auth, this.resetEmail)
  //     .then(() => {
  //       this.resetSuccess = 'Password reset email sent. Check your inbox.';
  //       this.resetError = '';
  //     })
  //     .catch((error) => {
  //       this.resetError = 'Error sending reset email. Please try again or check the email address.';
  //       this.resetSuccess = '';
  //       console.error(error);
  //     });
  // }

  toggleReset() {
    this.showReset = !this.showReset;
    if (this.showReset) {
      this.resetEmail = this.email; // Pre-fill with login email
      this.resetSuccess = '';
      this.resetError = '';
    } else {
      this.resetEmail = '';
      this.resetSuccess = '';
      this.resetError = '';
    }
  }

  onResetPassword(event: Event) {
    event.preventDefault();
    if (!this.resetEmail) {
      this.resetError = 'Please enter an email address.';
      return;
    }
    const auth = getAuth();
    sendPasswordResetEmail(auth, this.resetEmail)
      .then(() => {
        this.resetSuccess = 'Password reset email sent. Check your inbox.';
        this.resetError = '';
      })
      .catch((error) => {
        this.resetError = 'Error sending reset email. Please try again or check the email address.';
        this.resetSuccess = '';
        console.error(error);
      });
  }

}
